import React, { useState } from 'react';
import { Dialog, Fab, Typography } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { setConfirmationDialog, setSnackbar } from '../redux';
import AutomaticTestDialog from './AutomaticTestDialog';

export default () => {
  const confirmationDialog = useSelector(state => state.tasks.confirmationDialog);
  const [closeNote, setCloseNote] = useState(null);
  const [automaticTestReasonId, setAutomaticTestReasonId] = useState(null);
  const dispatch = useDispatch();
  const automaticTestCloseReasons = useSelector(state => state.tasks.automaticTestCloseReasons);
  const closeReasonIdRequiredNote = 3;

  return (
    <Dialog open={confirmationDialog.open}>
      <div
        className="ConfirmationDialog"
        style={{
          position: 'fixed',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
        }}
      >
        {confirmationDialog.title.map(x => (
          <Typography
            key={x}
            gutterBottom
            component="p"
            variant="h5"
            align="center"
            style={{
              color: x.color || 'white',
              backgroundColor: x.backgroundColor || 'none',
              borderRadius: x.borderRadius || '0%',
              fontSize: x.fontSize || '',
            }}
          >
            {x.text}
          </Typography>
        ))}
        {automaticTestCloseReasons.length > 0 ? (
          <AutomaticTestDialog
            handleTestReasonId={value => setAutomaticTestReasonId(value)}
            handleCloseNote={value => setCloseNote(value)}
          />
        ) : null}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Fab
            id="ConfirmButton"
            style={{ marginTop: '25px', marginLeft: '25px', backgroundColor: '#5ab85a' }}
            onClick={() => {
              if (
                confirmationDialog.title &&
                confirmationDialog.title[0] &&
                confirmationDialog.title[0].text &&
                confirmationDialog.title[0].text.startsWith('Нивата на устройство')
              ) {
                if (automaticTestReasonId === null || automaticTestReasonId === undefined) {
                  dispatch(
                    setSnackbar({ open: true, message: 'Моля изберете причина за затваряне!' })
                  );
                  return;
                }
              }
              if (confirmationDialog.onConfirm && confirmationDialog.onCancel) {
                const isCloseNoteValid = !!(
                  closeNote !== '' &&
                  closeNote !== null &&
                  closeNote !== ' ' &&
                  closeNote !== '.'
                );

                if (automaticTestReasonId === closeReasonIdRequiredNote && !isCloseNoteValid) {
                  dispatch(setSnackbar({ open: true, message: 'Поле "Забележка" е задължително' }));
                  return;
                }

                confirmationDialog.onConfirm(automaticTestReasonId, closeNote);
                confirmationDialog.onCancel();
                setAutomaticTestReasonId(null);
                setCloseNote(null);
              } else {
                dispatch(
                  setConfirmationDialog({
                    open: false,
                    title: [],
                    onConfirm: null,
                    onCancel: null,
                  })
                );
              }
            }}
          >
            <Check style={{ color: 'white' }} />
          </Fab>
          <Fab
            style={{ marginTop: '25px', marginRight: '25px', backgroundColor: '#da291c' }}
            onClick={() =>
              confirmationDialog.onCancel
                ? confirmationDialog.onCancel()
                : dispatch(
                    setConfirmationDialog({
                      open: false,
                      title: [],
                      onConfirm: null,
                      onCancel: null,
                    })
                  )
            }
          >
            <Close style={{ color: 'white' }} />
          </Fab>
        </div>
      </div>
    </Dialog>
  );
};
